import { render, staticRenderFns } from "./RecommendEvaluation.vue?vue&type=template&id=5d35bec0&scoped=true"
import script from "./RecommendEvaluation.vue?vue&type=script&lang=js"
export * from "./RecommendEvaluation.vue?vue&type=script&lang=js"
import style0 from "./RecommendEvaluation.vue?vue&type=style&index=0&id=5d35bec0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d35bec0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d35bec0')) {
      api.createRecord('5d35bec0', component.options)
    } else {
      api.reload('5d35bec0', component.options)
    }
    module.hot.accept("./RecommendEvaluation.vue?vue&type=template&id=5d35bec0&scoped=true", function () {
      api.rerender('5d35bec0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/components/RecommendEvaluation.vue"
export default component.exports